import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 16px 8px;
  width: 100%;
  min-height: auto;

  .entity-container {
    margin-top: 6px;
    .entity {
      padding: 5px 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      cursor: pointer;
      transition: all .5s ease;

      &:hover {
        background-color: ${(props) => `${props.theme.colors.inactive}33`};
        border-radius: 6px;
        opacity: 0.9;
      }
    }
  }
`;

export default { Wrapper };
